export default __webpack_public_path__ + "fbd6916aa5e597066c324b579051a74c.svg";